import { GetTokenMetadata, GetUsdPrice, SwapRouteInfo } from "@bridgesplit/abf-react";
import { toTokenAmount, tokenAmountToUiNumber } from "@bridgesplit/utils";

export interface SwapRouteMinInputUsd {
    /** USD value of the binding minimum — the unit-safe comparison key. */
    minUsd: number;
    /** Same minimum in its own token's UI units, for display copy. */
    amountUi: number;
    symbol: string;
}

/**
 * Largest per-step minimum across configured routes, compared in USD — step minimums are
 * denominated in different input tokens, so comparing token amounts directly would be
 * apples-to-oranges. Steps missing token metadata or an oracle price are skipped: fail open,
 * the backend enforces the true minimum.
 */
export function maxSwapRouteMinInputUsd(
    routes: SwapRouteInfo[] | undefined,
    getMetadata: GetTokenMetadata,
    getUsdPrice: GetUsdPrice
): SwapRouteMinInputUsd | undefined {
    let max: SwapRouteMinInputUsd | undefined;
    for (const route of routes ?? []) {
        for (const step of route.steps) {
            if (!step.minInputAmount) continue;
            const metadata = getMetadata(step.inputMint);
            if (!metadata) continue;
            const usdPrice = getUsdPrice(step.inputMint);
            if (!usdPrice) continue;
            const amountUi = tokenAmountToUiNumber(toTokenAmount(step.minInputAmount, metadata.decimals));
            if (amountUi === undefined) continue;
            const minUsd = amountUi * usdPrice;
            if (!max || minUsd > max.minUsd) max = { minUsd, amountUi, symbol: metadata.symbol };
        }
    }
    return max;
}
